import request from '../utils/request';
import { APIHOST } from '../config';

export async function fetchGrowthbookFeatures() {
  const path = '/v1/growthbook_features';
  return request('GET', APIHOST + path);
}
